import script from "./Waline.vue?vue&type=script&setup=true&lang=js"
export * from "./Waline.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__